import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgModule } from '../../svg/svg.module';
import { ModalDeliveryServiceDescriptionComponent } from './modal-delivery-service-description.component';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
  declarations: [ModalDeliveryServiceDescriptionComponent],
  imports: [CommonModule, SvgModule, MatDialogModule],
  entryComponents: [ModalDeliveryServiceDescriptionComponent]
})
export class ModalDeliveryServiceDescriptionModule {}
